<div class="mx-auto bg-gray-300 h-100 print:bg-white">
  <div class="p-5 bg-white header">
    <div class="flex flex-col mx-auto md:max-w-4xl lg:max-w-6xl">
      <h1 class="pb-3 text-3xl text-blue-900" id="container-title">Estimate services</h1>

      @if (locationsReady()) {
        <ul class="border divide-y rounded-lg border-gray divide-gray">
          @for (item of estimateItems; track item; let i = $index) {
            <li class="p-4">
              <button
                (click)="estimateInfo(item.id)"
                [disabled]="item.id === 0 && servicesLocked()"
              [ngClass]="{
                'opacity-50 cursor-not-allowed pointer-events-none':
                  item.id === 0 && servicesLocked()
              }"
                class="flex p-0 text-lg w-100 align-items-center justify-content-between">
                <div class="pr-4 text-left service-list-item-action w-3/4">
                  <div class="text-xl service-list-item-action-title">
                    <div class="flex justify-start align-middle items-center">
                      <span class="flex badge text-white badge-steps justify-content-center align-items-center">
                        {{ i + 1 }}
                      </span>
                      <span class="pl-1">
                        {{ item.label | translate }}
                      </span>
                    </div>
                  </div>
                  @if (!item.value?.length) {
                    <div class="place-holder font-bold text-blue-500 truncate service-list-item-action-link"
                      >
                      <ng-container>{{ item.placeholder | translate }}</ng-container>
                    </div>
                  } @else {
                    @for (lineItem of item.value; track lineItem) {
                      <div class="place-holder font-bold text-blue-500 service-list-item-action-link"
                        >
                        {{ lineItem | translate }}
                      </div>
                    }
                  }
                </div>
                <div class="flex flex-shrink-0 service-list-item-icon align-items-center">
                  @if (item.id === 2 && item.value && item.value != '' && item.value != 'Select Insurance') {
                    <span
                      class="pr-2 text-base font-bold text-th-primary">
                      Remove
                    </span>
                  }
                  <div class="position-relative">
                    @if (item.id === 0) {
                      <span
                        class="flex badge badge-primary justify-content-center align-items-center">
                        {{ item.selectedCount }}
                      </span>
                    }
                    <span [ngClass]="item.id === 2 && item.value && item.value != '' && item.value != 'Select Insurance' ? 'icon-minus-outline' : 'icon-plus-outline' "
                    class="text-3xl text-th-primary"></span>
                  </div>
                </div>
              </button>
            </li>
          }
        </ul>
      } @else {
        <div class="border divide-y rounded-lg border-gray divide-gray">
          <estimate-service-placeholder [serviceCount]=3>
          </estimate-service-placeholder>
        </div>
      }

      @if (showNotPerformedProcedures()) {
        <ul class="border divide-y rounded-lg border-gray divide-gray mt-5">
          <li class="p-4">
            <button (click)="openNotPerformedProcedures()"
              [disabled]="notPerformedProceduresDisabled()"
              [ngClass]="{
                'opacity-50 cursor-not-allowed pointer-events-none': notPerformedProceduresDisabled()
              }"
              class="flex p-0 text-lg w-100 align-items-center justify-content-between">
              <div class="pr-4 text-left service-list-item-action">
                <div class="text-xl service-list-item-action-title">
                  <div class="flex justify-start align-middle items-center">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6 text-primary"
                      viewBox="0 0 20 20"
                      fill="currentColor">
                      <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd" />
                      </svg>
                      <span class="pl-1">
                        {{ notPerformedProcedures.label | translate }}
                      </span>
                    </div>
                  </div>
                  @if (allProceduresPerformed()) {
                    <div class="place-holder font-bold text-blue-500 truncate service-list-item-action-link">{{ notPerformedProcedures.allPerformedNote | translate }}</div>
                  } @else {
                    <div class="place-holder font-bold text-blue-500 truncate service-list-item-action-link">
                      <ng-container>{{ notPerformedProcedures.placeholder | translate }}</ng-container>
                    </div>
                  }
                </div>
              </button>
            </li>
          </ul>
        }

        @if (estimate?.serviceGroups?.length) {
          <rs-session-toolbar (startOverClicked)="restartSession($event)">
          </rs-session-toolbar>
        }

        <rs-alert [alert]="alert"></rs-alert>
      </div>
    </div>

    @if (loading) {
      <div class="flex my-4 w-100 align-items-center justify-content-center">
        <pa-spinner [loading]="loading">
        </pa-spinner>
      </div>
    }

    <div class="flex flex-col pb-5" id="estimateContainer">
      <div class="print-header">
        <h2 class="mb-0 font-bold">{{printConfig.organizationName}}</h2>
        <p class="mb-4">{{printConfig.dateTimeStamp}}</p>
        @if (printConfig.locationName?.length > 1) {
          <p class="mb-4">Location: {{printConfig.locationName}}</p>
        }
        @if (printConfig.insurance?.length > 1) {
          <p class="mb-4">Insurance: {{printConfig.insurance}}</p>
        }
      </div>

      @if (!blockedByDisclaimer()) {
        @if (features?.['pricing.zeroEstimateDisplay'] && hasZeroProcedure) {
          <div class="relative flex flex-col w-full my-4 align-items-center align-self-center md:max-w-4xl lg:max-w-6xl">
            <zero-estimate class="w-full"
              [estimate]="estimate"
              [message]="orgLayoutConfig?.config?.zeroEstimateMessage"
              [linkLabel]="orgLayoutConfig?.config?.zeroEstimateContactLinkLabel"
              (requestCall)="openContactMe()">
            </zero-estimate>
          </div>
        } @else {
          <div class="relative flex flex-col my-4 align-items-center align-self-center md:max-w-4xl lg:max-w-6xl">
            <estimate [estimate]="estimate" [language]="estimateLanguage"
              [features]="features"
              [estimateDisclaimerAcknowledged]="estimateDisclaimerAcknowledged"
              [encounterId]="estimate?.encounterId"
              [appName]="'pricing'" #estimateView
              id="estimateView">
            </estimate>
            <div class="absolute p-0 pointer-events-none inset-2">
              @if (features?.consumerShoppingEstimateScore) {
                <estimate-score #estimateScore [estimate]="estimate">
                </estimate-score>
              }
            </div>
          </div>
        }
      } @else {
        <div class="relative flex flex-col my-4 align-items-center align-self-center md:max-w-4xl lg:max-w-6xl">
          <estimate-disclaimer [estimateDisclaimerConfig]="estimateDisclaimerConfig"
            (estimateDisclaimerAcknowledged)="setEstimateDisclaimerAcknowledged()">
          </estimate-disclaimer>
        </div>
      }

      <estimate-actions [estimate]="estimate" [loading]="loading" (actionClicked)="toEstimateActions($event)">
      </estimate-actions>
    </div>
  </div>